if (typeof document === "undefined") return;
var createStylesheet = (chunkId, fullhref, oldTag, resolve, reject) => {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	if (__webpack_require__.nc) {
		linkTag.nonce = __webpack_require__.nc;
	}
	var onLinkComplete = (event) => {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && event.type;
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + errorType + ": " + realHref + ")");
			err.name = "ChunkLoadError";
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			if (linkTag.parentNode) linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;


	if (oldTag) {
		oldTag.parentNode.insertBefore(linkTag, oldTag.nextSibling);
	} else {
		document.head.appendChild(linkTag);
	}
	return linkTag;
};
var findStylesheet = (href, fullhref) => {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = (chunkId) => {
	return new Promise((resolve, reject) => {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, null, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	"runtime": 0
};

__webpack_require__.f.miniCss = (chunkId, promises) => {
	var cssChunks = {"src_script_home_index_ts-src_css_link_module_scss":1,"src_script_confirm_new_email_index_ts-src_css_link_module_scss-node_modules_babel_runtime_hel-2a3bc1":1,"src_script_console_index_ts-src_css_link_module_scss-node_modules_babel_runtime_helpers_esm_d-c14fc2":1,"src_script_image_index_ts-src_css_link_module_scss-node_modules_babel_runtime_helpers_esm_def-4853e6":1,"src_css_news_module_scss":1,"src_script_info_ts-src_script_module_dom_element_email_link_create_admin_ts-src_script_module-2e2389":1,"src_script_my_account_index_ts-src_css_link_module_scss-node_modules_babel_runtime_helpers_es-dacdeb":1,"src_script_new_email_index_ts-src_css_link_module_scss-node_modules_babel_runtime_helpers_esm-e6c511":1,"src_script_register_index_ts-src_css_link_module_scss-node_modules_babel_runtime_helpers_esm_-1f5154":1,"src_script_special_register_ts-src_css_link_module_scss-src_css_portal_form_module_scss-node_-67d3f8":1,"src_script_login_index_ts-src_css_link_module_scss-node_modules_babel_runtime_helpers_esm_def-1f7141":1,"src_script_request_password_reset_ts-src_css_link_module_scss-src_css_portal_form_module_scss-b01eac":1,"src_script_password_reset_index_ts-src_css_link_module_scss-node_modules_babel_runtime_helper-afd9d6":1,"src_script_cn_routes_index_ts-src_css_link_module_scss-node_modules_babel_runtime_helpers_esm-ea9c6e":1,"src_script_bangumi_index_ts-src_css_link_module_scss-node_modules_babel_runtime_helpers_esm_d-dc4452":1,"src_script_news_index_ts-src_css_link_module_scss-node_modules_babel_runtime_helpers_esm_defi-2091d4":1,"src_script_entry_font_ts":1,"src_script_home_async_ts-src_css_lazyload_module_scss":1,"src_script_module_nav_bar_internal_nav_bar_ts":1,"src_script_confirm_new_email_async_ts-src_css_popup_window_module_scss":1,"src_script_console_async_ts":1,"src_script_image_async_ts":1,"src_script_my_account_async_ts-src_css_popup_window_module_scss":1,"src_script_new_email_async_ts-src_css_portal_form_module_scss":1,"src_script_register_async_ts":1,"src_script_login_async_ts-src_css_popup_window_module_scss":1,"src_script_password_reset_async_ts":1,"src_script_cn_routes_async_ts-src_css_multi_language_manual_module_scss":1,"src_script_bangumi_helper_ts-src_script_bangumi_shared_var_ts-src_script_module_dom_element_h-235294":1,"src_script_bangumi_image_ts-src_css_lazyload_module_scss":1,"src_script_module_player_player_ts":1,"src_script_news_all_news_ts":1,"src_script_news_news_ts-src_css_lazyload_module_scss-src_css_multi_language_manual_module_scss":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(() => {
			installedCssChunks[chunkId] = 0;
		}, (e) => {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr

// no prefetching

// no preloaded